var _rect, _rect2, _rect3, _rect4, _path, _path2, _g, _path3, _g2, _ellipse, _ellipse2, _ellipse3, _g3, _g4, _ellipse4, _ellipse5, _ellipse6, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 423,
    viewBox: "0 0 494 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_575)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_76_575)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 232.041,
    y: 257.665,
    width: 261.959,
    height: 165.335,
    rx: 14.1323,
    fill: "white",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 458.041,
    y: 325.533,
    width: 8.00001,
    height: 72,
    rx: 4,
    transform: "rotate(90 458.041 325.533)",
    fill: "#95ABBC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 454.041,
    y: 347.665,
    width: 8.00001,
    height: 68,
    rx: 4,
    transform: "rotate(90 454.041 347.665)",
    fill: "#95ABBC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 462.041,
    y: 369.797,
    width: 8.00001,
    height: 76,
    rx: 4,
    transform: "rotate(90 462.041 369.797)",
    fill: "#95ABBC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_76_575)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.686 351.295C346.686 373.346 328.854 391.197 306.888 391.197C284.922 391.197 267.09 373.346 267.09 351.295C267.09 329.243 284.922 311.393 306.888 311.393C328.854 311.393 346.686 329.243 346.686 351.295Z",
    stroke: "#0A2640",
    strokeWidth: 13.3928
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 232,
    y: 287,
    width: 74,
    height: 122
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.405 346.998L287.269 287.841L232.365 357.573L261.548 408.468L305.405 346.998Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.687 351.294C346.687 373.345 328.855 391.196 306.889 391.196C284.923 391.196 267.091 373.345 267.091 351.294C267.091 329.243 284.923 311.392 306.889 311.392C328.855 311.392 346.687 329.243 346.687 351.294Z",
    stroke: "#0DBBFC",
    strokeWidth: 13.3928
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_76_575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 281,
    y: 282,
    width: 91,
    height: 85
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M311.544 352.182L371.54 366.873L339.835 283.913L281.272 282.96L311.544 352.182Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_76_575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.489 385.535C267.597 374.249 261.396 349.763 272.643 330.842C283.889 311.92 308.321 305.732 327.214 317.018C346.106 328.303 352.306 352.79 341.06 371.711C329.814 390.632 305.381 396.82 286.489 385.535Z",
    stroke: "#69E6A6",
    strokeWidth: 13.3928
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.942,
    cy: 275,
    rx: 4.8,
    ry: 5,
    fill: "#FC5B00"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.142,
    cy: 275,
    rx: 4.8,
    ry: 5,
    fill: "#ECAA00"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.342,
    cy: 275,
    rx: 4.8,
    ry: 5,
    fill: "#009D10"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_76_575)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_76_575)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.14209,
    width: 493.858,
    height: 231.898,
    rx: 15.0305,
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9223,
    y: 68.1805,
    width: 11.7769,
    height: 54.1739,
    rx: 5.88847,
    transform: "rotate(90 82.9223 68.1805)",
    fill: "#95ABBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.207,
    y: 68.1091,
    width: 11.9197,
    height: 269.981,
    rx: 5.95985,
    transform: "rotate(90 367.207 68.1091)",
    fill: "#8FB6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.909 70.3059C385.685 70.3059 386.3 70.4863 386.754 70.8472C387.208 71.208 387.435 71.7066 387.435 72.343C387.435 72.762 387.305 73.1442 387.045 73.4896C386.785 73.8349 386.37 74.1492 385.8 74.4324C386.49 74.7622 386.981 75.1095 387.272 75.4742C387.563 75.8351 387.709 76.2541 387.709 76.7314C387.709 77.4376 387.462 78.0021 386.97 78.425C386.477 78.8441 385.802 79.0536 384.944 79.0536C384.036 79.0536 383.338 78.8557 382.849 78.46C382.36 78.0603 382.116 77.4958 382.116 76.7663C382.116 75.7924 382.709 75.0338 383.897 74.4906C383.361 74.188 382.977 73.862 382.744 73.5128C382.511 73.1597 382.395 72.7659 382.395 72.3313C382.395 71.7144 382.622 71.2236 383.076 70.8588C383.534 70.4902 384.145 70.3059 384.909 70.3059ZM383.07 76.7896C383.07 77.2552 383.231 77.618 383.553 77.8779C383.879 78.1379 384.335 78.2679 384.921 78.2679C385.499 78.2679 385.949 78.1321 386.271 77.8605C386.593 77.5889 386.754 77.2164 386.754 76.743C386.754 76.3666 386.603 76.033 386.3 75.742C385.998 75.4471 385.47 75.1619 384.717 74.8864C384.139 75.1347 383.72 75.4102 383.46 75.7129C383.2 76.0116 383.07 76.3705 383.07 76.7896ZM384.898 71.0916C384.413 71.0916 384.032 71.208 383.757 71.4409C383.481 71.6737 383.344 71.9841 383.344 72.3721C383.344 72.729 383.458 73.0356 383.687 73.2917C383.916 73.5478 384.339 73.8038 384.956 74.0599C385.511 73.8271 385.903 73.5769 386.132 73.3091C386.364 73.0414 386.481 72.729 386.481 72.3721C386.481 71.9802 386.339 71.6698 386.056 71.4409C385.776 71.208 385.39 71.0916 384.898 71.0916ZM394.553 74.671C394.553 76.1416 394.32 77.2397 393.855 77.9653C393.393 78.6908 392.685 79.0536 391.731 79.0536C390.815 79.0536 390.118 78.6831 389.641 77.942C389.164 77.197 388.925 76.1067 388.925 74.671C388.925 73.1888 389.156 72.0888 389.618 71.371C390.08 70.6532 390.784 70.2943 391.731 70.2943C392.654 70.2943 393.354 70.6687 393.832 71.4176C394.313 72.1664 394.553 73.2509 394.553 74.671ZM389.903 74.671C389.903 75.9088 390.048 76.8109 390.339 77.3774C390.631 77.94 391.094 78.2213 391.731 78.2213C392.375 78.2213 392.84 77.9362 393.127 77.3658C393.418 76.7915 393.564 75.8933 393.564 74.671C393.564 73.4488 393.418 72.5544 393.127 71.9879C392.84 71.4176 392.375 71.1324 391.731 71.1324C391.094 71.1324 390.631 71.4137 390.339 71.9763C390.048 72.535 389.903 73.4333 389.903 74.671ZM396.561 72.9657C396.561 73.6254 396.633 74.1201 396.777 74.4499C396.92 74.7797 397.153 74.9446 397.475 74.9446C398.111 74.9446 398.43 74.285 398.43 72.9657C398.43 71.6543 398.111 70.9985 397.475 70.9985C397.153 70.9985 396.92 71.1615 396.777 71.4874C396.633 71.8133 396.561 72.3061 396.561 72.9657ZM399.227 72.9657C399.227 73.8504 399.077 74.5197 398.779 74.9737C398.484 75.4238 398.049 75.6488 397.475 75.6488C396.932 75.6488 396.509 75.418 396.206 74.9562C395.907 74.4945 395.758 73.831 395.758 72.9657C395.758 72.085 395.902 71.4215 396.189 70.9752C396.48 70.529 396.909 70.3059 397.475 70.3059C398.038 70.3059 398.47 70.5368 398.773 70.9985C399.076 71.4603 399.227 72.116 399.227 72.9657ZM401.683 76.3763C401.683 77.0398 401.755 77.5365 401.898 77.8663C402.042 78.1922 402.277 78.3552 402.603 78.3552C402.928 78.3552 403.169 78.1942 403.324 77.8721C403.479 77.5462 403.557 77.0476 403.557 76.3763C403.557 75.7129 403.479 75.222 403.324 74.9038C403.169 74.5818 402.928 74.4208 402.603 74.4208C402.277 74.4208 402.042 74.5818 401.898 74.9038C401.755 75.222 401.683 75.7129 401.683 76.3763ZM404.354 76.3763C404.354 77.2571 404.205 77.9245 403.906 78.3785C403.611 78.8286 403.177 79.0536 402.603 79.0536C402.052 79.0536 401.627 78.8228 401.328 78.361C401.033 77.8993 400.886 77.2377 400.886 76.3763C400.886 75.4956 401.029 74.8321 401.316 74.3859C401.607 73.9396 402.036 73.7165 402.603 73.7165C403.154 73.7165 403.582 73.9455 403.889 74.4033C404.199 74.8573 404.354 75.515 404.354 76.3763ZM402.853 70.4281L398.133 78.9372H397.277L401.997 70.4281H402.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9223,
    y: 107.217,
    width: 11.7769,
    height: 54.1739,
    rx: 5.88847,
    transform: "rotate(90 82.9223 107.217)",
    fill: "#95ABBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.088,
    y: 107.444,
    width: 11.3237,
    height: 79.8619,
    rx: 5.66185,
    transform: "rotate(90 177.088 107.444)",
    fill: "#0DBBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.246 110.765C197.246 111.308 197.093 111.753 196.787 112.098C196.484 112.443 196.053 112.674 195.495 112.791V112.837C196.178 112.923 196.684 113.14 197.014 113.489C197.343 113.838 197.508 114.296 197.508 114.863C197.508 115.674 197.227 116.298 196.664 116.737C196.102 117.171 195.303 117.389 194.267 117.389C193.816 117.389 193.403 117.354 193.027 117.284C192.654 117.218 192.292 117.099 191.939 116.929V116.009C192.307 116.192 192.699 116.331 193.114 116.428C193.533 116.521 193.929 116.568 194.301 116.568C195.772 116.568 196.507 115.992 196.507 114.839C196.507 113.807 195.696 113.291 194.075 113.291H193.236V112.459H194.086C194.75 112.459 195.275 112.313 195.663 112.022C196.051 111.727 196.245 111.32 196.245 110.8C196.245 110.385 196.102 110.059 195.815 109.822C195.531 109.586 195.145 109.467 194.657 109.467C194.284 109.467 193.933 109.518 193.603 109.619C193.273 109.72 192.897 109.906 192.474 110.177L191.985 109.526C192.334 109.25 192.736 109.035 193.19 108.879C193.648 108.72 194.129 108.641 194.633 108.641C195.46 108.641 196.102 108.831 196.56 109.211C197.018 109.588 197.246 110.106 197.246 110.765ZM204.434 113.006C204.434 114.477 204.202 115.575 203.736 116.3C203.274 117.026 202.566 117.389 201.612 117.389C200.696 117.389 199.999 117.018 199.522 116.277C199.045 115.532 198.806 114.442 198.806 113.006C198.806 111.524 199.037 110.424 199.499 109.706C199.961 108.988 200.665 108.629 201.612 108.629C202.535 108.629 203.235 109.004 203.713 109.753C204.194 110.501 204.434 111.586 204.434 113.006ZM199.784 113.006C199.784 114.244 199.93 115.146 200.221 115.712C200.512 116.275 200.975 116.556 201.612 116.556C202.256 116.556 202.721 116.271 203.008 115.701C203.299 115.126 203.445 114.228 203.445 113.006C203.445 111.784 203.299 110.889 203.008 110.323C202.721 109.753 202.256 109.467 201.612 109.467C200.975 109.467 200.512 109.749 200.221 110.311C199.93 110.87 199.784 111.768 199.784 113.006ZM206.442 111.301C206.442 111.96 206.514 112.455 206.658 112.785C206.801 113.115 207.034 113.28 207.356 113.28C207.992 113.28 208.311 112.62 208.311 111.301C208.311 109.989 207.992 109.333 207.356 109.333C207.034 109.333 206.801 109.496 206.658 109.822C206.514 110.148 206.442 110.641 206.442 111.301ZM209.108 111.301C209.108 112.185 208.959 112.855 208.66 113.309C208.365 113.759 207.93 113.984 207.356 113.984C206.813 113.984 206.39 113.753 206.087 113.291C205.789 112.829 205.639 112.166 205.639 111.301C205.639 110.42 205.783 109.756 206.07 109.31C206.361 108.864 206.79 108.641 207.356 108.641C207.919 108.641 208.351 108.872 208.654 109.333C208.957 109.795 209.108 110.451 209.108 111.301ZM211.564 114.711C211.564 115.375 211.636 115.871 211.779 116.201C211.923 116.527 212.158 116.69 212.484 116.69C212.81 116.69 213.05 116.529 213.205 116.207C213.361 115.881 213.438 115.383 213.438 114.711C213.438 114.048 213.361 113.557 213.205 113.239C213.05 112.917 212.81 112.756 212.484 112.756C212.158 112.756 211.923 112.917 211.779 113.239C211.636 113.557 211.564 114.048 211.564 114.711ZM214.236 114.711C214.236 115.592 214.086 116.259 213.787 116.713C213.492 117.164 213.058 117.389 212.484 117.389C211.933 117.389 211.508 117.158 211.209 116.696C210.914 116.234 210.767 115.573 210.767 114.711C210.767 113.831 210.91 113.167 211.197 112.721C211.488 112.275 211.917 112.051 212.484 112.051C213.035 112.051 213.463 112.28 213.77 112.738C214.08 113.192 214.236 113.85 214.236 114.711ZM212.734 108.763L208.014 117.272H207.158L211.878 108.763H212.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9223,
    y: 145.956,
    width: 11.7769,
    height: 54.1739,
    rx: 5.88847,
    transform: "rotate(90 82.9223 145.956)",
    fill: "#95ABBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.885,
    y: 145.885,
    width: 11.9197,
    height: 317.66,
    rx: 5.95985,
    transform: "rotate(90 414.885 145.885)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.35 156.011H432.408V149.947C432.408 149.442 432.423 148.965 432.454 148.515C432.373 148.596 432.282 148.682 432.181 148.771C432.08 148.86 431.618 149.238 430.795 149.906L430.283 149.242L432.536 147.502H433.35V156.011ZM442.232 151.745C442.232 153.216 441.999 154.314 441.534 155.039C441.072 155.765 440.364 156.128 439.409 156.128C438.494 156.128 437.797 155.757 437.32 155.016C436.843 154.271 436.604 153.181 436.604 151.745C436.604 150.263 436.835 149.163 437.297 148.445C437.758 147.727 438.463 147.368 439.409 147.368C440.333 147.368 441.033 147.743 441.51 148.491C441.991 149.24 442.232 150.325 442.232 151.745ZM437.582 151.745C437.582 152.983 437.727 153.885 438.018 154.451C438.309 155.014 438.773 155.295 439.409 155.295C440.053 155.295 440.519 155.01 440.806 154.44C441.097 153.865 441.243 152.967 441.243 151.745C441.243 150.523 441.097 149.628 440.806 149.062C440.519 148.491 440.053 148.206 439.409 148.206C438.773 148.206 438.309 148.488 438.018 149.05C437.727 149.609 437.582 150.507 437.582 151.745ZM449.053 151.745C449.053 153.216 448.82 154.314 448.355 155.039C447.893 155.765 447.185 156.128 446.231 156.128C445.315 156.128 444.618 155.757 444.141 155.016C443.664 154.271 443.425 153.181 443.425 151.745C443.425 150.263 443.656 149.163 444.118 148.445C444.58 147.727 445.284 147.368 446.231 147.368C447.154 147.368 447.854 147.743 448.332 148.491C448.813 149.24 449.053 150.325 449.053 151.745ZM444.403 151.745C444.403 152.983 444.548 153.885 444.839 154.451C445.13 155.014 445.594 155.295 446.231 155.295C446.875 155.295 447.34 155.01 447.627 154.44C447.918 153.865 448.064 152.967 448.064 151.745C448.064 150.523 447.918 149.628 447.627 149.062C447.34 148.491 446.875 148.206 446.231 148.206C445.594 148.206 445.13 148.488 444.839 149.05C444.548 149.609 444.403 150.507 444.403 151.745ZM451.061 150.04C451.061 150.699 451.133 151.194 451.277 151.524C451.42 151.854 451.653 152.019 451.975 152.019C452.611 152.019 452.93 151.359 452.93 150.04C452.93 148.728 452.611 148.072 451.975 148.072C451.653 148.072 451.42 148.235 451.277 148.561C451.133 148.887 451.061 149.38 451.061 150.04ZM453.727 150.04C453.727 150.924 453.577 151.594 453.279 152.048C452.984 152.498 452.549 152.723 451.975 152.723C451.432 152.723 451.009 152.492 450.706 152.03C450.407 151.568 450.258 150.905 450.258 150.04C450.258 149.159 450.402 148.495 450.689 148.049C450.98 147.603 451.409 147.38 451.975 147.38C452.538 147.38 452.97 147.611 453.273 148.072C453.576 148.534 453.727 149.19 453.727 150.04ZM456.183 153.45C456.183 154.114 456.255 154.61 456.398 154.94C456.542 155.266 456.777 155.429 457.103 155.429C457.428 155.429 457.669 155.268 457.824 154.946C457.979 154.62 458.057 154.122 458.057 153.45C458.057 152.787 457.979 152.296 457.824 151.978C457.669 151.656 457.428 151.495 457.103 151.495C456.777 151.495 456.542 151.656 456.398 151.978C456.255 152.296 456.183 152.787 456.183 153.45ZM458.854 153.45C458.854 154.331 458.705 154.998 458.406 155.452C458.111 155.902 457.677 156.128 457.103 156.128C456.552 156.128 456.127 155.897 455.828 155.435C455.533 154.973 455.386 154.312 455.386 153.45C455.386 152.569 455.529 151.906 455.816 151.46C456.107 151.014 456.536 150.79 457.103 150.79C457.654 150.79 458.082 151.019 458.389 151.477C458.699 151.931 458.854 152.589 458.854 153.45ZM457.353 147.502L452.633 156.011H451.777L456.497 147.502H457.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9223,
    y: 184.695,
    width: 11.7769,
    height: 54.1739,
    rx: 5.88847,
    transform: "rotate(90 82.9223 184.695)",
    fill: "#95ABBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.115,
    y: 184.922,
    width: 11.3237,
    height: 253.889,
    rx: 5.66186,
    transform: "rotate(90 351.115 184.922)",
    fill: "#65E4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.078 194.75L370.605 187.132H365.966V186.241H371.629V187.015L368.148 194.75H367.078ZM375.482 189.553C376.378 189.553 377.082 189.776 377.595 190.222C378.111 190.664 378.369 191.272 378.369 192.044C378.369 192.925 378.087 193.615 377.525 194.116C376.966 194.616 376.194 194.867 375.208 194.867C374.25 194.867 373.518 194.713 373.014 194.407V193.475C373.286 193.65 373.623 193.788 374.027 193.889C374.43 193.986 374.828 194.034 375.22 194.034C375.903 194.034 376.432 193.873 376.809 193.551C377.189 193.229 377.379 192.763 377.379 192.154C377.379 190.967 376.652 190.373 375.197 190.373C374.828 190.373 374.335 190.43 373.718 190.542L373.218 190.222L373.538 186.241H377.769V187.132H374.364L374.149 189.687C374.595 189.597 375.039 189.553 375.482 189.553ZM380.47 188.779C380.47 189.438 380.541 189.933 380.685 190.263C380.829 190.593 381.061 190.757 381.383 190.757C382.02 190.757 382.338 190.098 382.338 188.779C382.338 187.467 382.02 186.811 381.383 186.811C381.061 186.811 380.829 186.974 380.685 187.3C380.541 187.626 380.47 188.119 380.47 188.779ZM383.135 188.779C383.135 189.663 382.986 190.333 382.687 190.787C382.392 191.237 381.958 191.462 381.383 191.462C380.84 191.462 380.417 191.231 380.115 190.769C379.816 190.307 379.667 189.644 379.667 188.779C379.667 187.898 379.81 187.234 380.097 186.788C380.388 186.342 380.817 186.119 381.383 186.119C381.946 186.119 382.379 186.35 382.681 186.811C382.984 187.273 383.135 187.929 383.135 188.779ZM385.591 192.189C385.591 192.853 385.663 193.349 385.807 193.679C385.95 194.005 386.185 194.168 386.511 194.168C386.837 194.168 387.078 194.007 387.233 193.685C387.388 193.359 387.466 192.86 387.466 192.189C387.466 191.526 387.388 191.035 387.233 190.717C387.078 190.395 386.837 190.234 386.511 190.234C386.185 190.234 385.95 190.395 385.807 190.717C385.663 191.035 385.591 191.526 385.591 192.189ZM388.263 192.189C388.263 193.07 388.113 193.737 387.815 194.191C387.52 194.641 387.085 194.867 386.511 194.867C385.96 194.867 385.535 194.636 385.236 194.174C384.942 193.712 384.794 193.051 384.794 192.189C384.794 191.308 384.938 190.645 385.225 190.199C385.516 189.753 385.945 189.529 386.511 189.529C387.062 189.529 387.491 189.758 387.797 190.216C388.108 190.67 388.263 191.328 388.263 192.189ZM386.761 186.241L382.041 194.75H381.186L385.906 186.241H386.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.9852,
    cy: 18.8431,
    r: 4.71077,
    fill: "#FC5B00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.8282,
    cy: 18.8431,
    r: 4.71077,
    fill: "#ECAA00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.6713,
    cy: 18.8431,
    r: 4.71077,
    fill: "#009D10"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_76_575)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.2157,
    y: 257.665,
    width: 192.175,
    height: 165.335,
    rx: 15.0305,
    fill: "white",
    fillOpacity: 0.18
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1133,
    cy: 275.6,
    rx: 4.71999,
    ry: 4.75784,
    fill: "#FC5B00"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9933,
    cy: 275.6,
    rx: 4.71999,
    ry: 4.75784,
    fill: "#ECAA00"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.8732,
    cy: 275.6,
    rx: 4.71999,
    ry: 4.75784,
    fill: "#009D10"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 9.30457,
    height: 23.2668,
    rx: 4.65228,
    transform: "matrix(1 0 0 -1 25.9086 402.528)",
    fill: "#0DBBFC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9.30457,
    height: 13.4841,
    rx: 4.65228,
    transform: "matrix(1 0 0 -1 44.5178 392.745)",
    fill: "#0DBBFC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1268,
    y: 316.864,
    width: 9.30457,
    height: 62.3972,
    rx: 4.65228,
    fill: "#0DBBFC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 81.736,
    y: 336.165,
    width: 9.30457,
    height: 43.0964,
    rx: 4.65229,
    fill: "#0DBBFC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100.345,
    y: 296.241,
    width: 9.30457,
    height: 83.02,
    rx: 4.65229,
    fill: "#95ABBC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 118.954,
    y: 320.565,
    width: 9.30457,
    height: 58.6957,
    rx: 4.65229,
    fill: "#0DBBFC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 137.563,
    y: 309.196,
    width: 9.30456,
    height: 70.0647,
    rx: 4.65228,
    fill: "#0DBBFC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 156.173,
    y: 347.269,
    width: 9.30456,
    height: 31.9918,
    rx: 4.65228,
    fill: "#0DBBFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_76_575",
    x: 98.9136,
    y: 124.538,
    width: 528.213,
    height: 431.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 66.5635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_76_575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_76_575",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_76_575",
    x: -68.5686,
    y: -68.7107,
    width: 631.279,
    height: 369.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 34.3553
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_76_575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_76_575",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_76_575",
    x: -67.495,
    y: 188.954,
    width: 329.596,
    height: 302.756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 34.3553
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_76_575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_76_575",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 493.858,
    height: 423,
    fill: "white",
    transform: "translate(0.14209)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_76_575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.0378,
    height: 93.0378,
    fill: "white",
    transform: "translate(260.305 304.773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_76_575"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.14209,
    width: 493.858,
    height: 231.898,
    rx: 15.0305,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/heroImage.0b595084d6be24d01e0d4d50c3a6241a.svg";
export { ForwardRef as ReactComponent };